<template>
  <div
    class="contact"
    :class="{ 'standalone-route': isStandaloneRoute }"
    id="contact"
  >
    <div class="container">
      <div class="address" data-aos="fade-right">
        <p class="bold">Pascal de Lucia</p>
        <p>Rue des Maraîchers 36 <br />1205 Geneva</p>
        <p>
          <a
            :href="`tel:+41794695599`"
            style="color: #ffff; text-decoration: none"
          >
            +41 (0)79 469 55 99
          </a>
        </p>
        <p>
          <a
            :href="`tel:+41227152399`"
            style="color: #ffff; text-decoration: none"
          >
            +41 (0)22 715 23 99
          </a>
        </p>
        <p>
          <a
            :href="`mailto:pdelucia@pdllaw.ch`"
            style="color: #ffff; text-decoration: none"
          >
            pdelucia@pdllaw.ch
          </a>
        </p>
      </div>
      <div class="form" data-aos="fade-left">
        <iframe
          width="100%"
          height="100%"
          style="border: 0"
          loading="lazy"
          allowfullscreen
          referrerpolicy="no-referrer-when-downgrade"
          :src="url"
        >
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactComponent",
  data() {
    return {
      name: "",
      phone: "",
      email: "",
      message: "",
      lawyer: "Pascal de Lucia",
      numberOfTries: 0
    };
  },
  methods: {
    reloadPage() {
      this.$router.go(this.$router.currentRoute);
    },
    sendAlert(title, message, callback = () => {}) {
      this.$iosAlert({
        title,
        text: message
      }).then(function () {
        callback();
      });
    },
    sendEmail() {
      const limit = 1;

      if (this.numberOfTries < limit) {
        if (this.name && this.email && this.message && this.phone) {
          this.$iosRemind({
            title: `Hi, ${this.name}`,
            text: `Please wait. Sending email to ${this.lawyer}`,
            remindDuration: 3000
          });

          const templateParams = {
            to_name: this.lawyer,
            from_name: this.name,
            phone_number: this.phone,
            from_email: this.email,
            message: this.message,
            reply_to: this.email
          };

          // eslint-disable-next-line no-undef
          emailjs
            .send("service_9v1zb1j", "template_s7qj9w8", templateParams)
            .then(
              response => {
                // console.log('SUCCESS!', response.status, response.text);

                if (response.status === 200) {
                  this.sendAlert(
                    `Hi, ${this.name}`,
                    `Your message has been received. We'll get back to you soon`
                  );
                  this.numberOfTries++;
                }
              },
              () => {
                // console.log(error)

                this.sendAlert(
                  `Sorry ${this.name}`,
                  `Message failed to send. Please try again later or call +41 79 469 55 99`,
                  this.reloadPage
                );
              }
            );
        } else {
          this.sendAlert(
            `Hi ${this.name}`,
            `Please fill all fields`,
            this.focusInput
          );
        }
      } else {
        const limitString = this.numberOfTries > 1 ? "times" : "time";
        this.sendAlert(
          `Sorry, ${this.name}`,
          `You can't use the form more than ${limit} ${limitString}`
        );
      }
    },

    focusInput() {
      this.$refs.name.focus();
    }
  },
  computed: {
    isStandaloneRoute() {
      return this.$route.name === "contact";
    },
    getLocale() {
      return window.localStorage.getItem("locale") || "EN";
    },
    url() {
      return `https://www.google.com/maps/embed/v1/place?key=AIzaSyC1rhXjlPt4b1lUk3ZPh_n671bQQzMaw1A&q=Rue%20des%20Mara%C3%AEchers%2036%201205%20Geneva&zoom=18&maptype=satellite&language=${this.getLocale}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.contact {
  background: #243956;
  height: fit-content;
  padding-top: 0;
  padding-bottom: 0;
}

.contact.standalone-route {
  padding-top: 6rem;
  padding-bottom: 0;
}

.container {
  position: relative;
  color: #ffffff;
  min-height: fit-content;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  justify-content: center;

  padding: 2rem;

  .address {
    padding: 2rem;
    padding-bottom: 0;
    text-align: center;
    font-size: 1rem;

    p {
      margin: 0.7rem 0;
    }
  }
  p.bold {
    font-weight: bolder;
  }

  .form {
    width: 100%;
    height: 100%;
    min-height: 500px;
    overflow: hidden;
    position: relative;
    z-index: 2;
    border-radius: 12px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);

    iframe {
      width: 100%;
      height: 100%;
      border: 0;
      display: block;
    }
  }
}

@media screen and (max-width: 600px) {
  .contact.standalone-route {
    padding-top: 6rem;
  }
  .address {
    margin-top: 0;
  }
}

@media only screen and (min-width: 600px) {
  .contact {
    min-height: fit-content;
    padding-top: 0;
    padding-bottom: 0;
  }

  .contact.standalone-route {
    padding-top: 10rem;
    padding-bottom: 0;
  }

  .container {
    color: #ffffff;
    min-height: fit-content;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    align-items: center;
    margin-top: 0;

    padding: 2rem 4rem;

    .address {
      text-align: left;
      font-size: 1.7rem;
      height: fit-content;
      padding: 2rem;
      padding-bottom: 0;
    }
    p.bold {
      font-weight: bolder;
    }

    .form {
      width: 100%;
      height: 100%;
      min-height: 600px;
      max-width: 100%;
      padding: 0;
      overflow: hidden;
    }
  }
}
</style>
